import {AbstractEvent} from "@/modules/base/events";
import {Notification} from '../entity';

export class AfterNotifyEvent extends AbstractEvent {
  constructor(
    protected notification: Notification,
  ) {
    super();
  }
}